var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.31,
    height: 21.311,
    viewBox: "0 0 21.31 21.311",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "facebook",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_392",
    "data-name": "Ret\\xE2ngulo 392",
    width: 21.31,
    height: 21.31,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1",
    "data-name": "Caminho 1",
    d: "M87.222,21.31V11.6h3.315l.474-3.788H87.222V5.446c0-1.065.355-1.894,1.894-1.894h2.013V.118C90.655.118,89.471,0,88.169,0a4.57,4.57,0,0,0-4.854,4.972V7.814H80V11.6h3.315V21.31Z",
    transform: "translate(-74.673 0.001)",
    fill: "#4d4d4d",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.c76be54ae971f540066797c8f5e0006a.svg";
export { ForwardRef as ReactComponent };